import { motion } from 'framer-motion';

export default function AboutSection() {
  return (
    <section id="about" className="py-24 lg:py-32 px-6 lg:px-12 bg-zinc-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2
              className="text-5xl sm:text-6xl lg:text-7xl font-light mb-8"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              About Studio
            </h2>
            <div className="space-y-6 text-base lg:text-lg text-zinc-600 font-light leading-relaxed">
              <p>
                우리는 브랜드의 본질을 이해하고, 그 가치를 디지털 경험으로 승화시키는 크리에이티브 스튜디오입니다.
              </p>
              <p>
                최신 기술과 예술적 감각을 결합하여 사용자에게 감동을 주는 경험을 만들어냅니다. 
                모든 프로젝트는 전략적 사고와 창의적 실행의 완벽한 조화를 추구합니다.
              </p>
              <p>
                디자인, 개발, 마케팅의 경계를 넘나들며 통합적인 솔루션을 제공합니다.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
            style={{ height: '600px' }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/4fdf57f029ded2b343a903450a98e18b.jpg"
              alt="Studio"
              className="w-full h-full object-cover"
              style={{ objectPosition: 'top' }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
